// query param used to preselect an element in the pathway menu, e.g. learning/12?elementId=34
export const ELEMENT_ID_SEARCH_PARAM = 'elementId';

export const PATHWAY_TAG_TYPES = {
    VESSEL_FLAG: 'VesselFlag',
    RANK_LEVEL: 'RankLevel',
    CREW_RANK: 'CrewRank',
    VESSEL_TYPE: 'VesselType',
    VESSEL_SUB_TYPE: 'VesselSubType',
    REGULATION: 'Regulation',
    COMPETENCE: 'Competence',
    ACCREDITATION: 'Accreditation',
    AUDIO: 'Audio',
    SUBTITLES: 'Subtitles',
};

export type UserPathwayTagType = (typeof PATHWAY_TAG_TYPES)[keyof typeof PATHWAY_TAG_TYPES];

export const userPathwayTagTypes: Record<UserPathwayTagType, string> = {
    VesselFlag: 'All vessel flags',
    RankLevel: 'All levels',
    CrewRank: 'All crew ranks',
    VesselType: 'All vessel types',
    Regulation: 'All regulations',
    Competence: 'All competences',
};
